<div class="w-full">
    <span class="font-semibold text-lg md:text-2xl pt-2">{{tituloFormulario}}</span>
    <hr class="my-4">

    <span class="text-base font-medium">
        {{descripsionGestiones}}
    </span>

    <form #myForm="ngForm">
        <mat-form-field class="w-full mt-2 fuse-mat-dense">
            <mat-icon>search</mat-icon>
            <input
                matInput
                placeholder="Buscar gestión..."
                #fruitInput
                id="gestionActual"
                name="gestionActual"
                [(ngModel)]="gestionActual"
                [matAutocomplete]="auto"
                (input)="onInputChange()" 
                required  
                #gestiones="ngModel"
                />
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event);">
                <mat-option *ngFor="let gestion of filteredGestiones" [value]="gestion.nombre">
                {{ gestion.nombre }}
                </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="gestiones.errors?.['required'] && gestiones.touched">
                Este campo es obligatorio
            </mat-error>
        </mat-form-field>
        
        
        <table mat-table [dataSource]="gestionesSeleccionadas"  class="w-full mb-2">
            <!-- Nombre Column -->
            <ng-container matColumnDef="nombre">
                <td mat-cell *matCellDef="let gestion"> {{gestion.nombre}} </td>
            </ng-container>

            <!-- acciones Column -->
            <ng-container matColumnDef="acciones">
                <td mat-cell *matCellDef="let gestion">
                    <button mat-icon-button (click)="remove(gestion)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-row *matRowDef="let row; columns: ['nombre', 'acciones']" class="border-b"></tr>
        </table>

        <div>
            <mat-label class="text-base font-medium">
                Ingrese el númeral o Correlativo para el elemento conformante
            </mat-label>
        </div>

        <div class="w-full flex flex-col md:flex-row gap-3 mt-3">
            <div class="flex w-full md:w-1/2 h-10 border border-gray-300 rounded-md">
                <label class="w-5/12 md:w-6/12 bg-gray-600 text-white flex items-center justify-center px-2 text-sm font-semibold">
                    No de Registro base
                </label>
                <input
                    matInput
                    id="numeroRegistro"
                    name="numeroRegistro"
                    [(ngModel)]="numeroRegistro"
                    readonly
                    class="w-7/12 md:w-6/12 px-3 text-sm font-semibold focus:outline-none" />
            </div>

            <div class="flex w-full md:w-1/2 items-start gap-3">
                @if(this.data.formFraccionamiento){
                    <!-- Solo letras -->
                    <mat-form-field class="w-5/12 fuse-mat-dense">
                        <input matInput 
                            class="font-semibold text-sm"
                            type="text" 
                            id="numeral" 
                            name="numeral" 
                            placeholder="Numeral"
                            [(ngModel)]="dataForm.literal"
                            pattern="^[a-zA-Z]+$"
                            required 
                            #letra="ngModel" />
                            <mat-error *ngIf="letra.errors?.['pattern'] && letra.touched">
                                Este campo solo admite letras
                            </mat-error>
                            <mat-error *ngIf="letra.errors?.['required'] && letra.touched">
                                Este campo es obligatorio
                            </mat-error>
                    </mat-form-field>
                }

                @if(!this.data.formFraccionamiento){
                    <!-- Solo números -->
                    <mat-form-field class="w-5/12 fuse-mat-dense">
                        <input matInput 
                            class="font-semibold text-sm"
                            type="text"
                            id="numeral" 
                            name="numeral" 
                            placeholder="Numeral"
                            [(ngModel)]="dataForm.literal"
                            pattern="^[0-9]+$"
                            min="1"
                            required
                            #digitos="ngModel" />
                            <mat-error *ngIf="digitos.errors?.['pattern'] && digitos.touched">
                                Este campo solo admite digitos.
                            </mat-error>
                            <mat-error *ngIf="digitos.errors?.['required'] && digitos.touched">
                                Este campo es obligatorio
                            </mat-error>
                    </mat-form-field>
                }

                <div class="w-7/12 border-b h-10 p-4 flex items-center justify-center">
                    <span 
                        class="font-semibold text-sm"
                        >{{
                            dataForm.literal
                            ? numeroRegistro + separador + dataForm.literal
                            : ''
                        }}
                    </span>
                </div>
            </div>
        </div>

         <mat-form-field class="w-full fuse-mat-dense">
            <mat-label>Nombre del Bien Cultural</mat-label>
            <input matInput 
                type="text" 
                id="nombreBienCultural" 
                name="nombreBienCultural" 
                [(ngModel)]="dataForm.nombreBienCultural" required 
                #nombreBienCultural="ngModel"/>
                <mat-error *ngIf="nombreBienCultural.errors?.['required'] && nombreBienCultural.touched">
                    Este campo es obligatorio
                </mat-error>
        </mat-form-field>

        <div class="flex-1 flex flex-col">
            <label class="flex items-center py-1 text-sm md:text-md font-semibold"
                >Descripción*</label>
            <textarea
            [(ngModel)]="dataForm.descripcion"
            name="descripcion" 
            id="descripcion" 
            rows="4" 
            class="flex-1 p-2 border-2 text-sm md:text-md leading-normal" 
            placeholder="Descripción"></textarea>
        </div>
    </form>
    

    <div class="w-full flex justify-center md:justify-end gap-3 mt-3">
        <button mat-raised-button
            class="rounded-sm w-full"  
            [color]="'secondary'"
            (click)="this.dialogRef.close(false)">
            Cancelar
        </button>

        <button mat-raised-button 
            [color]="'primary'" 
            class="rounded-sm w-full"
            type="submit"
            (click)="postfraccionamientoIntegracion()"
            [disabled]="!myForm.valid"
            >Agregar
        </button>
    </div>

</div>